<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['system_permissions'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-2" content-class="text-primary">
              <MemberPermissions :permissions="permissions" />
              <FeePermissions :permissions="permissions" />
              <SavingPermissions :permissions="permissions" />
              <SharePermissions :permissions="permissions" />
              <WithdrawPermissions :permissions="permissions" />
              <ChargePermissions :permissions="permissions" />
              <ReturnPermissions :permissions="permissions" />
              <LoanPermissions :permissions="permissions" />
              <LoanproductPermissions :permissions="permissions" />
              <ExpensePermissions :permissions="permissions" />
              <SmsPermissions :permissions="permissions" />
              <DocumentPermissions :permissions="permissions" />
              <SystemuserPermissions :permissions="permissions" />
              <RolePermissions :permissions="permissions" />
              <PaymentPermissions :permissions="permissions" />
              <ReportPermissions :permissions="permissions" />
              <SettingPermissions :permissions="permissions" />
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View System Permissions</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="start-page" centered hide-header hide-footer>
      <div class="text p-3">
        <div class="text-center"><i class="fs-1 text-danger mdi mdi-shield-lock-outline"></i></div>
        <center>
          <h3 class="text-primary fw-bold mb-3">
            System Permissions
          </h3>
        </center>
        <div class="row align-items-center">
          <div class="text-center col-1"><i class="fs-3 mdi mdi-information-outline text-primary"></i></div>
          <div class="text-center col-10 fs-5">System Permissions are the access rights and privileges assigned to a
            role to view and perform certain operations on the System.</div>
          <div class="text-center col-1"><i class="fs-3 mdi mdi-information-outline text-primary"></i></div>
        </div>
        <hr>
        <ul>
          <li>
            <p class="text-primary fs-6">
              Click on the <b>Tabs</b> on the left to view and manage permissions for each module.
            </p>
          </li>
          <li>
            <p class="text-danger fs-6">
              Turn on/off the <b>Switch</b> to enable/disable a permission.
            </p>
          </li>
          <li>
            <p class="text-dark fs-6">
              Permissions apply on the next <b>login in</b>.
            </p>
          </li>
        </ul>
      </div>
      <div class="text-center">
        <button class="btn btn-primary" @click.prevent="$bvModal.hide('start-page')">Understood</button>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import MemberPermissions from "../permissions/memberPermissions.vue";
import FeePermissions from "../permissions/feePermissions.vue";
import SavingPermissions from "../permissions/savingPermissions.vue";
import SharePermissions from "../permissions/sharePermissions.vue";
import WithdrawPermissions from "../permissions/withdrawPermissions.vue";
import ReturnPermissions from "../permissions/returnPermissions.vue";
import ChargePermissions from "../permissions/chargePermissions.vue";
import LoanPermissions from "../permissions/loanPermissions.vue";
import LoanproductPermissions from "../permissions/loanproductPermissions.vue";
import SmsPermissions from "../permissions/smsPermissions.vue";
import ExpensePermissions from "../permissions/expensePermissions.vue";
import RolePermissions from "../permissions/rolePermissions.vue";
import SystemuserPermissions from "../permissions/systemuserPermissions.vue";
import PaymentPermissions from "../permissions/paymentPermissions.vue";
import ReportPermissions from "../permissions/reportPermissions.vue";
import DocumentPermissions from "../permissions/documentPermissions.vue";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { permissionMethods, permissionComputed } from "@/state/helpers";
import SettingPermissions from "../permissions/settingPermissions.vue";
export default {
  page: {
    title: "System Permissions",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, PageHeader,
    MemberPermissions,
    FeePermissions,
    SavingPermissions,
    SharePermissions,
    WithdrawPermissions,
    ReturnPermissions,
    ChargePermissions,
    LoanPermissions,
    LoanproductPermissions,
    SmsPermissions,
    ExpensePermissions,
    RolePermissions,
    SystemuserPermissions,
    PaymentPermissions,
    ReportPermissions,
    SettingPermissions,
    DocumentPermissions
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Permissions",
      items: [{ text: "Dashboard", to: "/", }, { text: "System Permissions", active: true, },],
      isBusy: true,
      role: '',
      permission: '',
    };
  },
  computed: {
    ...permissionComputed,
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.permissions.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.permissions.length > 0) { a = false; } else { a = true; } return a },
  },
  mounted() {
    this.fetchPermissions();
    this.isBusy = false;
    this.$bvModal.show("start-page");
  },
  methods: {
    ...permissionMethods,
  },
};
</script>